import React from 'react'
import { Container } from './Container'

export const Footer = () => {
  return (
    <footer style={{textAlign: "center"}}>
      <Container>Made with ❤ by me</Container>
    </footer>
  );
}
